export default __webpack_public_path__ + "static/media/tag.a8f86d5b.svg";